import FunctionalComponent from './FunctionalComponent.vue'

export default FunctionalComponent
